import React from 'react';
import { I18n } from 'aws-amplify';
import PropTypes from 'prop-types';
import { useHookstate } from '@hookstate/core';
import { scrbData } from '../ScrbTools';
import { DataView } from 'primereact/dataview';
import { Card } from 'primereact/card';

Pricing.propTypes = {
    informations: PropTypes.object.isRequired
}

function Pricing(props) {

    const data = useHookstate(scrbData).get();
    const valueList = [
        { "genreInst": 4, "label": "prixBiomasse" },
        { "genreInst": 3, "label": "prixClim" },
        { "genreInst": 1, "label": "prixMazout1" },
        { "genreInst": 1, "label": "prixMazout2" },
        { "genreInst": 2, "label": "prixGaz" },
        { "genreInst": 5, "label": "prixPompe" }
    ]
    const informations = props.informations;

    const listTemplate = (items) => {
        return <div style={{ maxWidth: '60rem' }}>
            <div className="flex flex-column w-full lg:flex-row flex-wrap m-0 p-0 ">
                {items.map((item) => {
                    const genreData = data.installationColors[item.genreInst];
                    const title = <span><i className={genreData.icon + " "} style={{ fontSize: "2rem" }}></i> <div className='pt-3'>{I18n.get(item.label)}</div><hr /></span>;
                    return (
                        <div key={item.label} className="p-0">
                            <Card
                                title={title}
                                className={`border-1 border-round-xl border-${genreData.brut}-500 m-2 w-full lg:w-18rem lg:h-16rem`}
                                style={{ boxShadow: "0 0 4px 0 " + genreData.brut }}
                            >
                                <div className="text-3xl">
                                    {informations[item.label]}€
                                </div>
                                <div className="text-sm">{I18n.get("horsTaxes")}</div>
                            </Card>
                        </div>
                    );
                })}
            </div>
        </div>;
    }

    return <div className="flex flex-column align-items-start m-0 p-0">
        <DataView value={valueList} listTemplate={listTemplate} />
    </div>
}

export default Pricing;